import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as Styles from './styles';
const Title = forwardRef(({ children, ...titleProps }, ref) => {
    return (_jsx(Styles.Title, { ref: ref, ...titleProps, children: children }));
});
const Header = forwardRef(({ children, ...titleProps }, ref) => {
    return (_jsx(Styles.Header, { ref: ref, ...titleProps, children: children }));
});
const Body = forwardRef(({ children, ...titleProps }, ref) => {
    return (_jsx(Styles.Body, { ref: ref, ...titleProps, children: children }));
});
const Footer = forwardRef(({ children, ...buttonProps }, ref) => {
    return (_jsx(Styles.Footer, { ref: ref, ...buttonProps, children: children }));
});
export const ModalContent = {
    Title,
    Header,
    Body,
    Footer,
};
//# sourceMappingURL=index.js.map